<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'商品分类',ischange:true,width:'150px',clearable:true,filterable:true}" 
                :value="param.cateid"
                :list="catelist"
                @finish="(val)=> {
                    param.cateid=val.value;
                    param.ischange=true;
                    GetList();
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'发布人类型',ischange:true,width:'150px',clearable:true,filterable:true}" 
                :value="param.iscompany"
                :list="typelists"
                @finish="(val)=> {
                    param.iscompany=val.value;
                    param.ischange=true;
                    GetList();
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'物品类型',ischange:true,width:'150px',clearable:true,filterable:true}" 
                :value="param.type"
                :list="saletypelist"
                @finish="(val)=> {
                    param.type=val.value;
                    param.ischange=true;
                    GetList();
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'疫苗情况',ischange:true,width:'150px',clearable:true,filterable:true}" 
                :value="param.Fineness"
                :list="finenesslist"
                @finish="(val)=> {
                    param.Fineness=val.value;
                    param.ischange=true;
                    GetList();
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcselect :option="{placeholder:'请选择排序方式',ischange:true,width:'150px',clearable:true,filterable:true}" 
                :value="param.sort"
                :list="sortlist"
                @finish="(val)=> {
                    param.sort=val.value;
                    param.ischange=true;
                    GetList();
                }"
            />
        </el-form-item>
        <el-form-item>
        <wcinput :option="{placeholder:'名称/发布人/手机',clearable:true,ischange:true,width:'200px',isinput:true,iskeydown:true,clearable:true}" 
            :value="param.key"
            @finish="(val)=> {
                if(val.type=='input') {param.key=val.value;param.ischange=true}
                if(val.type=='change') {param.key=val.value;param.ischange=true}
                if(val.type=='keydown') GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'添加商品'}" @finish="$parent.JUMPVIEW({name:'EsAddGoods'})"/>
        </el-form-item>
        <el-form-item>
        <wcbutton 
            :option="{title:'取消选择',type:'del'}" 
            v-if="childhandleparam.type=='selectgoods'"
            @finish="(val)=> {
                childhandleparam.type='';
                childhandleparam.rollbackindex='';
                childhandleparam.rollbackobjname='';
            }" 
        />
        </el-form-item>
    </el-form>
</div>


<div class="TTL-table top20" :ref="objloading">
    <el-table :data="list" stripe="true" empty-text="" @selection-change="selecttable">
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column type="selection" />
        <el-table-column label="商品图" align="center">
            <template #default="scope">
                <div style="position:relative;" 
                    @click="(val)=> {
                        if(scope.row.video=='') return false;
                        this.videoparam.view=true;
                        this.videoparam.url=scope.row.video;
                    }"
                >
                <wcimage :option="{size:'middle',thumbtype:scope.row.thumbtype}" :value="scope.row.thumb" />
                <el-image :src="require('@/assets/icon/player.png')" v-if="scope.row.thumbtype==2" style="width:30px;height: 30px;position:absolute;top:0;left:calc((100% - 30px) / 2);top:calc((100% - 30px) / 2);" />
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="name" label="商品名称" align="center" min-width="120">
            <template #default="scope">
                <div class="comment-goodsname" @click="$parent.JUMPVIEW({name:'EsGoodsDetail',param:{id:scope.row.id}})">{{scope.row.name}}</div>
                <span class="ttl-finiss">（{{scope.row.Fineness}}）</span>
                <div class="er-goodsname-copy">
                <wcimage :option="{size:'mini'}" :value="require('@/assets/icon/copy.png')"  @click="$method.COPY_TEXT({title:scope.row.name}) "/>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="发布人" align="center">
            <template #default="scope">
            <span 
                class="comment-goodsname" 
                @click="(val)=> {
                    this.detailparam.id=scope.row.memberid;
                    this.detailparam.view=true;
                }"
            >{{scope.row.membername}}
            </span>
            </template>
        </el-table-column>
        <el-table-column prop="type" label="发布类型" align="center"/>
        <el-table-column prop="catename" label="所属分类" align="center"/>
        <el-table-column prop="price" label="预估金额" align="center"/>
        <el-table-column prop="name" label="红包金额" align="center" min-width="120">
            <template #default="scope">
                <div class="comment-goodsname" 
                    @click="(val)=> {
                        this.cashparam.view=true;
                        this.cashparam.data=scope.row.cashlog;
                    }"
                >{{scope.row.cash}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="inputtime" label="发布时间" align="center"/>
        <el-table-column label="设置置顶" align="center">
            <template #default="scope">
            <div class="comment-goodsname"
                @click="(val)=> {
                    editTop.view=true;
                    editTop.goodsid=scope.row.id;
                    editTop.idx_top_expire=scope.row.idx_top_expire;
                    editTop.list_top_expire=scope.row.list_top_expire;
                }"
            >
                {{scope.row.istop ? '已置顶，进行修改' : '设置置顶'}}
            </div>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="190">
            <template #default="scope">
            <div class="TTL-btn-info" v-if="childhandleparam.type!='selectgoods'">
                <wcbutton :option="{title:'编辑',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsEditGoods',param:{id:scope.row.id}})" class="left10"/>
                <wcbutton :option="{title:'删除',type:'del'}" @finish="delgoods(scope.row.id)" class="left10"/>
            </div>
            <div class="TTL-btn-info" v-if="childhandleparam.type=='selectgoods'">
                <wcbutton 
                :option="{title:'选择商品'}" 
                @finish="(val)=> {
                        $parent.JUMPVIEW({name:childhandleparam.rollbackobjname,param:{type:childhandleparam.type,index:childhandleparam.rollbackindex,data:scope.row}})
                        childhandleparam.type='';
                        childhandleparam.rollbackindex='';
                        childhandleparam.rollbackobjname='';
                    }" 
                />
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>


<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-select TTL-page-left">
            <wcselect :option="{placeholder:'请选择操作',ischange:true,isconfim:true}" 
                :value="handlevalue"
                :list="handleinfos"
                @finish="(val)=> {
                    changehandle(val.value)
                }"
            />
        </div>
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>


<!-- 编辑置顶时间 -->
<EditTop 
    :view="editTop.view" 
    :goodsid="editTop.goodsid" 
    :idxtop="editTop.idx_top_expire" 
    :listtop="editTop.list_top_expire" 
    @finish="(val)=> {
        editTop.view=false;
        GetList();
    }" 
/>

<!-- 视频播放器 -->
<wcvideo :view="videoparam.view" :url="videoparam.url" 
    @finish="(val)=> {
        this.videoparam.view=false;
    }" 
/>

<!-- 会员信息详情 -->
<MemberInfoShow :view="detailparam.view" :id="detailparam.id" 
    @finish="(val)=> {
        this.detailparam.view=false;
    }" 
/>

<!-- 红包金额详情 -->
<CashInfoShow :view="cashparam.view" :data="cashparam.data"
    @finish="(val)=> {
        this.cashparam.view=false;
    }"
/>

</template>

<script>
import INTERFACE_MODEL_GOODS from '@/Interface/Es/Goods/Goods';
import EditTop from '@/views/EsSetting/Module/EditTop';
import MemberInfoShow from '@/views/EsMembers/MemberInfoShow';
import CashInfoShow from '@/views/EsGoods/Module/CashInfoShow';
export default {

    components:{
        EditTop,MemberInfoShow,CashInfoShow
    },

    data() {
        return {
            objloading:'goods',
            param: {
                key:'',
                cateid:'',
                iscompany:'',
                type:'',
                Fineness:'',
                underline:'',
                sort:1,
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },

            typelists:[],
            catelist:[],
            saletypelist:[],
            finenesslist:[],
            underlines:[],
            list:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除数据'},
            ],

            childhandleparam: {
                type:'',
                rollbackobjname:'',
                rollbackindex:'',
            },
            sortlist:[
                {id:1,name:'默认排序'},
                {id:2,name:'按置顶排序'}
            ],
            editTop: {
                view:false,
                goodsid:'',
                idx_top_expire:'',
                list_top_expire:'',
            },
            videoparam: {
                view:false,
                url:'',
            },
            detailparam: {
                view:false,
                id:'',
            },
            cashparam: {
                view:false,
                data:[],
            },
            

        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
            this.GetMemberTypes(isfresh);
            this.GetCateInfos(isfresh);
            this.GetSalestypeList(isfresh);
            this.GetFinesstypeList(isfresh);
            this.GetUnderLines(isfresh);
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                // if(data.param) {
                //     for(var i in this.param) this.param[i]='';
                //     for(var i in data.param) this.param[i]=data.param[i];
                //     this.param.ischange=true;
                //     this.param.p=1;
                //     this.param.rollpage=10;
                // }
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                // if(data.param) {
                //     for(var i in this.param) this.param[i]='';
                //     for(var i in data.param) this.param[i]=data.param[i];
                //     this.param.ischange=true;
                //     this.param.p=1;
                //     this.param.rollpage=10;
                // }
                this.GetList();
            }


            //兄弟元素操作
            if(data.param.childtype && data.param.childtype!='') {
                this.childhandleparam.type=data.param.childtype;
                this.childhandleparam.rollbackindex=data.param.rollbackindex;
                this.childhandleparam.rollbackobjname=data.param.rollbackobjname;
            }
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_GOODS.GET_LIST(this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
            });
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.list.length;i++) this.list[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(val);
        },


        /** 批量操作 **/
        changehandle(index) {
            var ids=this.GetSelectDataIds(); //获取当前选中的id
            if(ids.length==0) {this.$notice({title:'消息提示',message:'请选择要批量执行的数据',type:'warning'});return false;}
            ids=ids.join(',');
            if(index==1) this.delgoods(ids);    //批量删除
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.list.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


        /** 删除商品信息 **/
        delgoods(ids) {
            INTERFACE_MODEL_GOODS.DEL_GOODS({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetList();
            });
        },


        /** 获取会员类型信息 **/
        GetMemberTypes(isfresh) {
            this.$method.GET_MEMBER_TYPES(isfresh).then((res) => {this.typelists=res;console.log(res)});
        },


        /** 获取商品类型信息 **/
        GetCateInfos(isfresh) {
            this.$method.GET_CATES_CHILD(isfresh).then((res) => {this.catelist=res;console.log(res)});
        },


        /** 获取商品类型信息 **/
        GetSalestypeList(isfresh) {
            this.$method.GET_SALES_TYPES(isfresh).then((res) => {this.saletypelist=res;console.log(res)});
        },


        /** 获取商品成色信息 **/
        GetFinesstypeList(isfresh) {
            this.$method.GET_FINENESS(isfresh).then((res) => {this.finenesslist=res;console.log(res)});
        },


        /** 获取商品上下架类型 **/
        GetUnderLines(isfresh) {
            this.$method.GET_GOODS_UNDER_LINE(isfresh).then((res) => {this.underlines=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.ttl-finiss {display:inline-block;width:100%;text-align:center;font-size:13px;color:#666666;letter-spacing:1px;color:#666eeb}
.answer-name {font-style: normal;color:#666eeb;}
.goods-commont {display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;width:100%;}
.goods-commont-box {display:inline-flex;width:200px;padding:15px 0;font-size:0;}
.goods-commont-box .el-image {width:50px;height:50px;border-radius: 50%;display: inline-block;}
.goods-commont-content {display: inline-block;width:calc(100% - 50px - 15px);min-height: 50px;font-size:0;}
.goods-commont-name {display: inline-flex;align-items: center;width:100%;font-size:12px;line-height:18px;position:relative;}
.goods-commont-time {position:absolute;right:0;font-size:12px;}
.goods-commont-name i {font-style:normal;color:#999999}
.content {display: inline-block;margin-top:0;}
.membername {font-size:13px;color:#666eeb;}
.comment-goodsname {
  color: #666eeb;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
}
.er-goodsname-copy {display:inline-flex;justify-content: center;}
</style>